export default __webpack_public_path__ + "static/media/clockGrey.b2365b91.svg";